// extracted by mini-css-extract-plugin
export default {"container":"HeroText_container__pcJ8F","textcontainer":"HeroText_textcontainer__D5gVW"};